module.exports = __webpack_public_path__ + "static/media/Borest-Regular.c7cc525d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Borest-Regular.otf
// module id = 2385
// module chunks = 50